import {
  BRAND_VALUE_FILTER_TYPE,
  getFilterValueFromFilterKey,
  isFilterKeyOfType,
} from "@faire/deprecated-retailer-visitor-shared/filters/filterKeys";
import { IUrlId } from "@faire/deprecated-retailer-visitor-shared/models/Category/IUrlId";
import { categoryBrandValuePath } from "@faire/deprecated-retailer-visitor-shared/paths/category/categoryBrandValuePath";
import { categoryPath } from "@faire/deprecated-retailer-visitor-shared/paths/category/categoryPath";
import { QueryParameters } from "@faire/deprecated-retailer-visitor-shared/paths/category/QueryParameters";
import { suppliersBrandValuePath } from "@faire/deprecated-retailer-visitor-shared/paths/suppliers/suppliersBrandValuePath";
import { suppliersPath } from "@faire/deprecated-retailer-visitor-shared/paths/suppliers/suppliersPath";
import { route as homepageRoute } from "@faire/web-api--source/routes/www/root";
import { logError } from "@faire/web/common/logging";
import {
  isNotUndefined,
  isTupleOfLengthGreaterThanOrEqual,
} from "@faire/web/common/typescriptUtils";
import type { IRoutingContext } from "@faire/web/ui/routing/types";
import { prependLocaleToUrl } from "@faire/web/ui/routing/util";

interface CategoryPagePathsProps {
  // always use english category name
  categoryUrlIds: [IUrlId, ...(IUrlId | undefined)[]] | [...IUrlId[], IUrlId];
  queryParams?: QueryParameters;
  filterByBrandValueOption?: string;
  routeType?: CategoryPagePaths.RouteType;
  routingContext: IRoutingContext;
}

export namespace CategoryPagePaths {
  export enum RouteType {
    CATEGORY = "category",
    SUPPLIERS = "suppliers",
  }

  /**
   * @deprecated
   *
   * Do not use this function as it is a heavy way to build a category path.
   * Instead use the more targetted helper functions under src/paths/category to get the
   * appropriate path depending on the parameters available.
   */
  export function index({
    categoryUrlIds,
    queryParams = {},
    filterByBrandValueOption,
    routeType = RouteType.CATEGORY,
    routingContext,
  }: CategoryPagePathsProps): string {
    const filteredCategoryUrlIds = categoryUrlIds.filter(
      isNotUndefined
    ) as IUrlId[];
    if (!isTupleOfLengthGreaterThanOrEqual(filteredCategoryUrlIds, 1)) {
      logError(
        new Error("CategoryPathPaths.index must have at least one category")
      );

      return prependLocaleToUrl(homepageRoute, routingContext);
    }

    if (routeType === RouteType.SUPPLIERS) {
      if (filterByBrandValueOption) {
        const brandValue = getBrandValueFromParam(filterByBrandValueOption);
        return suppliersBrandValuePath({
          urlIds: filteredCategoryUrlIds,
          brandValue,
          queryParams,
          routingContext,
        });
      } else {
        return suppliersPath({
          urlIds: filteredCategoryUrlIds,
          queryParams,
          routingContext,
        });
      }
    }

    if (filterByBrandValueOption) {
      const brandValue = getBrandValueFromParam(filterByBrandValueOption);

      return categoryBrandValuePath({
        urlIds: filteredCategoryUrlIds,
        brandValue,
        queryParams,
        routingContext,
      });
    } else {
      return categoryPath({
        urlIds: filteredCategoryUrlIds,
        queryParams,
        routingContext,
      });
    }
  }

  export const getRouteType = (suppliersCategoryName: string | undefined) => {
    return suppliersCategoryName
      ? CategoryPagePaths.RouteType.SUPPLIERS
      : CategoryPagePaths.RouteType.CATEGORY;
  };
}

const getBrandValueFromParam = (filterByBrandValueOption: string) => {
  let brandValue = filterByBrandValueOption;
  if (isFilterKeyOfType(filterByBrandValueOption, BRAND_VALUE_FILTER_TYPE)) {
    brandValue =
      getFilterValueFromFilterKey(filterByBrandValueOption) ?? brandValue;
  }
  return brandValue.replace(/_/g, "-");
};
